import { Link, useLocation } from 'react-router-dom';

type FooterLink = { name: string; labelEn: string; href: string };
type FooterColumn = { heading: string; headingEn: string; links: FooterLink[] };

export const FOOTER_COLUMNS: FooterColumn[] = [
  {
    heading: '執事を知る',
    headingEn: 'Understanding Butlers',
    links: [
      { name: '執事を知る一覧', labelEn: 'Overview', href: '/butler' },
      { name: '執事の仕事とは', labelEn: "A Butler's Work", href: '/butler/work' },
      { name: '執事の歴史', labelEn: 'History', href: '/butler/history' },
      { name: '日本に執事はいるのか', labelEn: 'Butlers in Japan', href: '/butler/japan' },
      { name: '執事になるには', labelEn: 'Becoming a Butler', href: '/butler/become' },
      { name: '家政婦・秘書との違い', labelEn: 'Butler vs Others', href: '/butler/difference' },
    ],
  },
  {
    heading: '執事ベルについて',
    headingEn: 'About Butler Bell',
    links: [
      { name: '執事ベルについて', labelEn: 'About', href: '/about' },
      { name: '経歴と実績', labelEn: 'Career', href: '/about/career' },
      { name: '理念と哲学', labelEn: 'Philosophy', href: '/about/philosophy' },
      { name: '資格と専門技能', labelEn: 'Skills', href: '/about/skills' },
      { name: '三代目会長としての役割', labelEn: 'Role as Chairman', href: '/about/chairman' },
    ],
  },
  {
    heading: '執事の知恵',
    headingEn: 'Butler Wisdom',
    links: [
      { name: '執事の知恵一覧', labelEn: 'Wisdom Overview', href: '/wisdom' },
      { name: 'おもてなし', labelEn: 'Hospitality', href: '/wisdom/hospitality' },
      { name: 'フォーマルマナー', labelEn: 'Etiquette', href: '/wisdom/etiquette' },
      { name: '執事の技術', labelEn: 'Butler Skills', href: '/wisdom/butler-skills' },
      { name: '品格とエレガンス', labelEn: 'Elegance', href: '/wisdom/elegance' },
      { name: 'コラム記事一覧', labelEn: 'All Articles', href: '/wisdom/articles' },
    ],
  },
  {
    heading: '食卓とテーブルマナー',
    headingEn: 'At the Table',
    links: [
      { name: 'テーブルマナーの基本', labelEn: 'Table Manners', href: '/wisdom/table-manners' },
      { name: '洋食のマナー', labelEn: 'Western Dining', href: '/wisdom/table-manners/western' },
      { name: '和食のマナー', labelEn: 'Japanese Dining', href: '/wisdom/table-manners/japanese' },
      { name: 'ワインのマナー', labelEn: 'Wine Etiquette', href: '/wisdom/table-manners/wine' },
    ],
  },
  {
    heading: 'もてなしと暮らし',
    headingEn: 'Hospitality & Home',
    links: [
      { name: '来客対応の作法', labelEn: 'Receiving Guests', href: '/wisdom/hospitality/guest-reception' },
      { name: '贈り物のマナー', labelEn: 'Gift Etiquette', href: '/wisdom/hospitality/gift-giving' },
      { name: '季節のおもてなし', labelEn: 'Seasonal Hospitality', href: '/wisdom/hospitality/seasonal' },
      { name: '紳士の身だしなみ', labelEn: 'Grooming', href: '/wisdom/appearance' },
      { name: '住空間の整え方', labelEn: 'Living Space', href: '/wisdom/living-space' },
    ],
  },
  {
    heading: '執事ベルのコラム',
    headingEn: "Bell's Column",
    links: [
      { name: 'コラム一覧', labelEn: 'Column Index', href: '/blog' },
      { name: '執事の日常', labelEn: 'Daily Life', href: '/blog/daily-life' },
      { name: '執事の視点', labelEn: 'Perspective', href: '/blog/perspective' },
      { name: '執事の歴史探訪', labelEn: 'History Notes', href: '/blog/history' },
      { name: '世界の執事文化', labelEn: 'Global Culture', href: '/blog/global-culture' },
    ],
  },
  {
    heading: '全日本執事協会',
    headingEn: 'The Association',
    links: [
      { name: '協会について', labelEn: 'About the Association', href: '/related/butler-association' },
      { name: '設立と沿革', labelEn: 'Origin', href: '/related/butler-association/origin' },
      { name: '協会の理念', labelEn: 'Principles', href: '/related/butler-association/philosophy' },
      { name: '活動内容', labelEn: 'Activities', href: '/related/butler-association/activity' },
      { name: '執事の認定制度', labelEn: 'Certification', href: '/related/butler-association/certification' },
    ],
  },
  {
    heading: 'THE BUTLER 執事サービス',
    headingEn: 'THE BUTLER',
    links: [
      { name: 'THE BUTLERについて', labelEn: 'About THE BUTLER', href: '/related/the-butler' },
      { name: 'サービス思想', labelEn: 'Service Philosophy', href: '/related/the-butler/service' },
      { name: '選抜と育成', labelEn: 'Selection and Training', href: '/related/the-butler/selection' },
      { name: '執事が働く現場', labelEn: 'Where Butlers Work', href: '/related/the-butler/scene' },
    ],
  },
  {
    heading: '日本執事アカデミー',
    headingEn: 'Japan Butler Academy',
    links: [
      { name: 'アカデミーについて', labelEn: 'About the Academy', href: '/related/butler-academy' },
      { name: '学びの全体像', labelEn: 'Curriculum', href: '/related/butler-academy/curriculum' },
      { name: '指導陣', labelEn: 'Instructors', href: '/related/butler-academy/instructor' },
      { name: '資格を取るには', labelEn: 'Qualification', href: '/related/butler-academy/certification' },
      { name: '学びはじめる前に', labelEn: 'Before You Start', href: '/related/butler-academy/admission' },
    ],
  },
  {
    heading: '統括する事業',
    headingEn: 'Our Organisations',
    links: [
      { name: '事業の一覧', labelEn: 'All Organisations', href: '/related' },
      { name: 'クイーンズバトラー', labelEn: "Queen's Butler", href: '/related/queens-butler' },
    ],
  },
  {
    heading: '講座・研修のご依頼',
    headingEn: 'Lectures & Training',
    links: [
      { name: 'ご依頼の一覧', labelEn: 'All Services', href: '/services' },
      { name: '企業研修・セミナー', labelEn: 'Corporate Training', href: '/services/corporate-training' },
      { name: 'プライベート執事', labelEn: 'Private Butler', href: '/services/private-butler' },
      { name: 'マナー講座', labelEn: 'Manner Courses', href: '/services/manner-course' },
      { name: 'コンサルティング', labelEn: 'Consulting', href: '/services/consulting' },
      { name: '講座・講演のご案内', labelEn: 'Lectures', href: '/lectures' },
    ],
  },
  {
    heading: 'メディア関係者の方へ',
    headingEn: 'For Media',
    links: [
      { name: 'メディアのご依頼', labelEn: 'Media Enquiries', href: '/media' },
      { name: 'テレビ出演', labelEn: 'Television', href: '/media/tv' },
      { name: '雑誌・新聞掲載', labelEn: 'Press', href: '/media/press' },
      { name: 'ラジオ出演', labelEn: 'Radio', href: '/media/radio' },
      { name: '書籍・著作', labelEn: 'Books', href: '/media/books' },
      { name: '写真ギャラリー', labelEn: 'Gallery', href: '/media/gallery' },
    ],
  },
];

export const FOOTER_ROUTES = FOOTER_COLUMNS.flatMap((column) =>
  column.links.map((link) => link.href),
);

const BOTTOM_LINKS: FooterLink[] = [
  { name: 'ホーム', labelEn: 'Home', href: '/' },
  { name: 'お問い合わせ', labelEn: 'Contact', href: '/contact' },
  { name: 'プライバシーポリシー', labelEn: 'Privacy Policy', href: '/privacy' },
  { name: '特定商取引法に基づく表記', labelEn: 'Legal Notice', href: '/legal' },
  { name: 'サイトマップ', labelEn: 'Sitemap', href: '/sitemap' },
];

export default function CommonFooter() {
  const { pathname } = useLocation();
  const isEnglish = pathname === '/en' || pathname.startsWith('/en/');
  const href = (path: string) => (isEnglish ? (path === '/' ? '/en' : `/en${path}`) : path);

  return (
    <footer className="bg-[#1a1a1a] text-white" lang={isEnglish ? 'en' : 'ja'}>
      <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8 py-16 md:px-8">
        <div className="grid grid-cols-1 gap-8 sm:gap-10 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          <div className="space-y-5 xl:pr-8">
            <Link
              to={isEnglish ? '/en' : '/'}
              className="inline-block text-3xl font-light tracking-wide text-amber-400 hover:text-amber-300"
              style={{ fontFamily: '"Noto Serif JP", serif' }}
            >
              {isEnglish ? 'Butler Bell' : '執事ベル'}
            </Link>
            <p className="max-w-sm text-sm leading-7 text-gray-400">
              {isEnglish
                ? 'Sharing genuine hospitality inherited from butler culture, from professional training to private butler service.'
                : '執事文化から受け継ぐ、本物のおもてなしの価値をお伝えします。研修から執事サービスまで、上質な体験づくりを支えます。'}
            </p>
          </div>
          {FOOTER_COLUMNS.map((column) => (
            <nav
              key={column.heading}
              aria-label={isEnglish ? column.headingEn : column.heading}
            >
              <h2 className="text-base font-medium text-amber-400">
                {isEnglish ? column.headingEn : column.heading}
              </h2>
              <div
                className="mb-5 mt-2 w-8 border-b"
                style={{ borderColor: 'rgba(200,169,106,.8)' }}
                aria-hidden="true"
              />
              <ul className="space-y-3">
                {column.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={href(link.href)}
                      className="text-sm leading-7 text-gray-400 transition-colors hover:text-amber-400 sm:leading-6"
                    >
                      {isEnglish ? link.labelEn : link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
        <div
          className="mt-12 border-t pt-8"
          style={{ borderColor: 'rgba(200,169,106,.4)' }}
        >
          <nav
            aria-label={isEnglish ? 'Utility links' : 'ユーティリティリンク'}
            className="flex flex-col items-center gap-4 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-x-8 sm:gap-y-3"
          >
            {BOTTOM_LINKS.map((link) => (
              <Link
                key={link.href}
                to={href(link.href)}
                className="text-sm leading-7 text-gray-400 transition-colors hover:text-amber-400 sm:leading-6"
              >
                {isEnglish ? link.labelEn : link.name}
              </Link>
            ))}
          </nav>
          <div className="mt-8 text-center text-sm text-gray-500">
            © {new Date().getFullYear()} Butler Bell. All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
